import type { BlockType } from '@unifyapps/defs/types/block';
import type { ContextualDialogComponentType } from '@unifyapps/defs/types/blocks';
import type BlocksRegistry from '../../../../context/RegistryProvider/BlocksRegistry';

export const getContextualDialogsForBlocks = (
  blocks: Record<string, BlockType>,
  registry: BlocksRegistry,
) => {
  const contextualDialogsForBlocks: Record<string, string | undefined> = {};
  const blockKeys = Object.keys(blocks);
  const blockKeysLength = blockKeys.length;

  for (let i = 0; i < blockKeysLength; i++) {
    const bId = blockKeys[i];
    if (blocks[bId].component.componentType === 'ContextualDialog') {
      const contextualDialogBlock = blocks[bId] as BlockType<ContextualDialogComponentType>;
      const blockVersion = registry.getBlockVersionByBlock(contextualDialogBlock);

      // Only include contextual dialogs with version < 1 (i.e., 0 or undefined)
      // Version >= 1 contextual dialogs use explicit event configuration
      if (blockVersion >= 1) {
        continue;
      }

      const dialogBlockId = contextualDialogBlock.component.content.dialogBlockId;
      if (!dialogBlockId) continue;

      if (!contextualDialogsForBlocks[dialogBlockId]) {
        contextualDialogsForBlocks[dialogBlockId] = bId;
      }
    }
  }
  return contextualDialogsForBlocks;
};
